<template>
  <el-dialog
    title="注册"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="registerForm"
      :model="form"
      :rules="rules"
      label-width="80px"
      @submit.native.prevent="handleSubmit"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          v-model="form.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input
          v-model="form.email"
          placeholder="请输入邮箱"
          type="email"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          v-model="form.password"
          placeholder="请输入密码"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          v-model="form.confirmPassword"
          placeholder="请再次输入密码"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.agreement">
          我已阅读并同意
          <el-button type="text" @click="showTerms">服务条款</el-button>
          和
          <el-button type="text" @click="showPrivacy">隐私政策</el-button>
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button 
        type="primary" 
        :loading="loading"
        :disabled="!form.agreement"
        @click="handleSubmit"
      >
        注册
      </el-button>
      <div class="login-link">
        已有账号？
        <el-button type="text" @click="handleLogin">
          立即登录
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { registerUser } from '@/api/system.js'

export default {
  name: 'RegisterForm',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      form: {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        agreement: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.registerForm.validate(async valid => {
        if (valid) {
          if (!this.form.agreement) {
            this.$message.warning('请阅读并同意服务条款和隐私政策')
            return
          }
          this.loading = true
          try {
            let params = {... this.form};
            registerUser(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("注册成功!");
                this.$refs['registerForm'].resetFields();
                this.handleLogin();
              } else {
                console.log(res.data.message);
                this.$message.error('注册失败，请重试')
              }
            })
          } catch (error) {
            console.log(error);
            this.$message.error('注册失败，请重试')
          } finally {
            this.loading = false
          }
        }
      })
    },
    handleClose() {
      this.$refs.registerForm.resetFields()
      this.$emit('update:visible', false)
    },
    handleLogin() {
      this.handleClose()
      this.$emit('show-login')
    },
    showTerms() {
      // TODO: 显示服务条款
      this.$message('服务条款页面开发中...')
    },
    showPrivacy() {
      // TODO: 显示隐私政策
      this.$message('隐私政策页面开发中...')
    }
  }
}
</script>

<style lang="less" scoped>
.register-form {
  .form-header {
    text-align: center;
    margin-bottom: 30px;

    h2 {
      font-size: 24px;
      color: var(--text-primary);
      margin-bottom: 10px;
    }

    p {
      color: var(--text-regular);
      font-size: 14px;
    }
  }

  .el-form {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .form-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .dialog-footer {
    text-align: center;
  }

  .login-link {
    margin-top: 15px;
    text-align: center;
    font-size: 14px;
    color: var(--text-regular);

    .el-button {
      padding: 0 5px;
    }
  }

  :deep(.el-dialog__body) {
    padding-bottom: 0;
  }

  :deep(.el-form-item__content) {
    .el-button--text {
      padding: 0;
      font-size: 14px;
    }
  }

  .agreement {
    margin-top: 10px;
    font-size: 14px;
    color: var(--text-regular);

    .el-button {
      padding: 0 5px;
    }
  }
}
</style> 
